import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import '../styles/PdfConverter.css';

const PdfConverter: React.FC = () => {
  const [text, setText] = useState('');

  const handleConvert = () => {
    const doc = new jsPDF();
    doc.text(text, 10, 10);
    doc.save('documento.pdf');
  };

  return (
    <div className="pdf-converter">
      <h2>Conversor de Arquivos para PDF</h2>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={10}
        className="w-full p-2 border"
        placeholder="Digite ou cole o texto que deseja converter em PDF..."
      />
      <button onClick={handleConvert} className="mt-2 p-2 bg-blue-500 text-white">Converter para PDF</button>
      {/* Espaço para anúncio */}
    </div>
  );
};

export default PdfConverter; 